import { createAction, props } from '@ngrx/store';

import { GreenHouseMap } from 'app/shared/features/map-row-selector/models';

import { GreenHouseMapFilters } from './greenhouse-map.state';

export const updateGreenHouseMaps = createAction(
    '[GreenHouse] Update Green House Maps',
    props<{ greenHouseMapList: GreenHouseMap[] }>(),
);

export const updateGreenHouseMapFilters = createAction(
    '[GreenHouse] Update Green House Map Filters',
    props<{ greenHouseMapFilters: Partial<GreenHouseMapFilters> | undefined }>(),
);

export const updateRecentRowNumber = createAction(
    '[GreenHouse] Update Recent Row Number Filter',
    props<{ recentRowNumber: number }>(),
);

export const resetSearchParams = createAction('[GreenHouse] Reset Search Params');
